import { reactToCwp } from '../../../../common/react-utils'
import { Header } from './Header'

export default reactToCwp(Header)
